import PublicPackageApi from '@/api/public';
import store from '@/store';
import Vue from 'vue';

const getSensorTypes = async (store) => {
  const listByKey = store.getters['sensorTypes/listByKey'];
  if (Object.keys(listByKey).length === 0) {
    await store.dispatch('sensorTypes/getList')
  }
  return listByKey;
}

export default {
  namespaced: true,

  state: {
    stat: {},
    sensorsState: {},
    meta: {},
    loading: false,
    error: null,
    params: {
      hash: null,
      samples: 1,
      start_date: null,
      stop_date: null
    }
  },

  actions: {
    async getStat(ctx) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);
      try {
        await getSensorTypes(store);
        const { data, meta } = await PublicPackageApi.getChart(ctx.getters.params);
        ctx.commit('setStat', data);
        ctx.commit('initSensorsStateMap');
        ctx.commit('setMeta', meta);
      } catch (err) {
        console.log('ERR: ', err);
        ctx.dispatch('errors/pushError', err, { root: true });
        ctx.commit('setError', err);
      } finally {
        ctx.commit('setLoading', false);
      }
    },

    changeParams(context, params) {
      context.commit('changeParams', params);
    }
  },

  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },
    setError(state, err) {
      state.error = err;
    },
    setMeta(state, meta) {
      state.meta = meta;
    },
    setStat(state, data) {
      const knownKeys = store.getters['sensorTypes/listByKey'];
      for (const item of data) {
        for (const key in item) {
          if (!knownKeys[key]) {
            continue;
          }
          const sensorValues = item[key];
          Vue.set(state.stat, key, {
            key,
            type: knownKeys[key],
            stat: {
              min: parseFloat(sensorValues.min).toFixed(2),
              max: parseFloat(sensorValues.max).toFixed(2),
              avg: parseFloat(sensorValues.avg).toFixed(2),
            }
          });
        }
      }
    },

    initSensorsStateMap(state) {
      for (const key in state.stat) {
        state.sensorsState[key] = { active: true }
      }
    },

    setSensorActivity(state, { key, value }) {
      state.sensorsState[key].active = value;
    },

    changeParams(state, data) {
      Object.assign(state.params, data);
    }
  },

  getters: {
    meta: state => state.meta,
    error: state => state.error,
    loading: state => state.loading,
    stat: state => state.stat,
    sensorsState: state => state.sensorsState,
    params: state => state.params
  }
};
